import { ROUTES } from "const";
import { CS24 } from "./cs24";
import { CSU24 } from "./csu24";
import { M24 } from "./m24";
import { MUMC24 } from "./mumc24";
import { ESB } from "./esb";
import { ESBSE } from "./esbse";
import { ICDL } from "./icdl";
import { INFO } from "./info";
import { CV } from "./cv";
import { CV2 } from "./cv2";
import { DS2 } from "./ds2";
import { EMOZIONI } from "./emozioni";
import { PR } from "./pr";
import { MU } from "./mu";
import { BU2 } from "./bu2";
import { PFU } from "./pfu";
import { courseService } from "libs";
import { MNE } from "./mne";
import { MNESE } from "./mnese";
import { MNESC } from "./mnesc";
import { RCPFU } from "./rcpfu";
import { UCSU } from "./ucsu";
import { RCSU } from "./rcsu";
import { RC30 } from "./rc30";
import { UM30 } from "./um30";
import { CM30 } from "./cm30";
import { TFA } from "./tfa";
import { MR } from "./mr";
import { RCCFUALL } from "./rccfuall";
import { DIGCOMP } from "./digcomp";
import { IUL30 } from "./iul30";
import { UNT30 } from "./unt30";
import { ABILITAZIONE60CFU } from "./abilitazione60cfu";
import { ABILITAZIONE30CFU } from "./abilitazione30cfu";
import { ABILITAZIONE30CFUMANIFESTO } from "./abilitazione30cfumanifesto";
import { ABILITAZIONE60CFUMANIFESTO } from "./abilitazione60cfumanifesto";
import { CORSI3036 } from "./corsi3036";
import { TFAINDIRE } from "./tfaindire";
import { TFAINDIRE_UNICAMILLUS } from "./tfaindireUnicamillus";
import { TFACLASSICO_UNICAMILLUS } from "./tfaClassicoUnicamillus";
import { ABILITAZIONE30CFUMANIFESTO_UNICAMILLUS } from "./abilitazione30cfumanifestoUnicamillus";
import { ABILITAZIONE60CFUMANIFESTO_UNICAMILLUS } from "./abilitazione60cfumanifestoUnicamillus";
import { ABILITAZIONE30CFUMANIFESTO_UNITELMA } from "./abilitazione30cfumanifestoUnitelma";
import { ABILITAZIONE60CFUMANIFESTO_UNITELMA } from "./abilitazione60cfumanifestoUnitelma";
import { ABILITAZIONE60CFUMANIFESTO_REGGIO } from "./abilitazione60cfumanifestoReggio";
import { ABILITAZIONE30CFUMANIFESTO_REGGIO } from "./abilitazione30cfumanifestoReggio";

export class CoursePlugin {
  static async getDashboardCards(course, userCourse) {
    const registrationCode = userCourse.registrationCode;

    let cards = [];
    let notices = [];

    if (course.metadata) {
      if (course.metadata.dashboard && course.metadata.dashboard.length > 0) {
        switch (course.metadata.dashboard) {
          case "MU":
            cards = await MU.getDashboardCards(registrationCode);
            notices = MU.getDashboardNotices();
            break;

          case "ESB":
            cards = ESB.getDashboardCards();
            break;

          case "ESBSE":
            cards = ESBSE.getDashboardCards();
            break;

          case "MNE":
            cards = await MNE.getDashboardCards(registrationCode);
            break;

          case "MNESE":
            cards = MNESE.getDashboardCards();
            break;

          case "MNESC":
            cards = await MNESC.getDashboardCards(registrationCode);
            break;

          case "ICDL":
            cards = ICDL.getDashboardCards();
            break;

          case "DIGCOMP":
            cards = DIGCOMP.getDashboardCards(userCourse.aa);
            notices = DIGCOMP.getDashboardNotices(course.code);
            break;

          case "CS24":
            cards = await CS24.getDashboardCards(registrationCode);
            notices = CS24.getDashboardNotices();
            break;

          case "CSU24":
            cards = await CSU24.getDashboardCards(registrationCode);
            notices = CSU24.getDashboardNotices();
            break;

          case "UCSU":
            cards = await UCSU.getDashboardCards(registrationCode);
            notices = UCSU.getDashboardNotices();
            break;

          case "RCSU":
            cards = await RCSU.getDashboardCards(registrationCode);
            notices = RCSU.getDashboardNotices();
            break;

          case "M24":
            cards = await M24.getDashboardCards(registrationCode);
            notices = M24.getDashboardNotices();
            break;

          case "MUMC24":
            cards = await MUMC24.getDashboardCards(registrationCode);
            notices = MUMC24.getDashboardNotices();
            break;

          case "INFO":
            cards = INFO.getDashboardCards();
            break;

          case "CV":
            cards = CV.getDashboardCards();
            break;

          case "CV2":
            cards = CV2.getDashboardCards();
            break;

          case "PR":
            cards = PR.getDashboardCards();
            break;

          case "MR":
            cards = await MR.getDashboardCards(registrationCode);
            break;

          case "DS2":
            cards = await DS2.getDashboardCards(registrationCode);
            break;

          case "BU2":
            cards = await BU2.getDashboardCards(registrationCode);
            notices = BU2.getDashboardNotices();
            break;

          case "EMOZIONI":
            cards = EMOZIONI.getDashboardCards();
            break;

          case "PFU":
            cards = await PFU.getDashboardCards(course.code, registrationCode);
            notices = PFU.getDashboardNotices(course.code);
            break;

          case "RCPFU":
            cards = await RCPFU.getDashboardCards(
              course.code,
              registrationCode
            );
            notices = RCPFU.getDashboardNotices(course.code);
            break;

          case "RC30":
            cards = await RC30.getDashboardCards(
              registrationCode,
              userCourse.idExamSession
            );
            notices = RC30.getDashboardNotices(
              userCourse.idExamSession,
              userCourse.aa,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "UM30":
            cards = await UM30.getDashboardCards(
              registrationCode,
              userCourse.idExamSession
            );
            notices = UM30.getDashboardNotices(
              userCourse.idExamSession,
              userCourse.aa,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "CM30":
            cards = await CM30.getDashboardCards(
              registrationCode,
              userCourse.idExamSession
            );
            notices = CM30.getDashboardNotices(
              userCourse.idExamSession,
              userCourse.aa,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "IUL30":
            cards = await IUL30.getDashboardCards(
              registrationCode,
              userCourse.idExamSession
            );
            notices = IUL30.getDashboardNotices(
              userCourse.idExamSession,
              userCourse.aa,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "UNT30":
            cards = await UNT30.getDashboardCards(
              registrationCode,
              userCourse.idExamSession
            );
            notices = UNT30.getDashboardNotices(
              userCourse.idExamSession,
              userCourse.aa,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "TFA":
            cards = await TFA.getDashboardCards(registrationCode);
            notices = await TFA.getDashboardNotices(registrationCode);
            break;

          case "RCCFUALL":
            cards = await RCCFUALL.getDashboardCards(
              course.code,
              registrationCode
            );
            notices = RCCFUALL.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass
            );
            break;


          case "ABILITAZIONE60CFU":
            cards = await ABILITAZIONE60CFU.getDashboardCards(
              course.code,
              registrationCode
            );
            notices = ABILITAZIONE60CFU.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "ABILITAZIONE30CFU":
            cards = await ABILITAZIONE30CFU.getDashboardCards(
              course.code,
              registrationCode
            );
            notices = ABILITAZIONE30CFU.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass
            );
            break;

          case "ABILITAZIONE30CFUMANIFESTO":
            cards = await ABILITAZIONE30CFUMANIFESTO.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE30CFUMANIFESTO.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE30CFUMANIFESTO_UNICAMILLUS":
            cards = await ABILITAZIONE30CFUMANIFESTO_UNICAMILLUS.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE30CFUMANIFESTO_UNICAMILLUS.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE30CFUMANIFESTO_UNITELMA":
            cards = await ABILITAZIONE30CFUMANIFESTO_UNITELMA.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE30CFUMANIFESTO_UNITELMA.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE30CFUMANIFESTO_REGGIO":
            cards = await ABILITAZIONE30CFUMANIFESTO_REGGIO.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE30CFUMANIFESTO_REGGIO.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE60CFUMANIFESTO":
            cards = await ABILITAZIONE60CFUMANIFESTO.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE60CFUMANIFESTO.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE60CFUMANIFESTO_UNICAMILLUS":
            cards = await ABILITAZIONE60CFUMANIFESTO_UNICAMILLUS.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE60CFUMANIFESTO_UNICAMILLUS.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE60CFUMANIFESTO_UNITELMA":
            cards = await ABILITAZIONE60CFUMANIFESTO_UNITELMA.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE60CFUMANIFESTO_UNITELMA.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "ABILITAZIONE60CFUMANIFESTO_REGGIO":
            cards = await ABILITAZIONE60CFUMANIFESTO_REGGIO.getDashboardCards(
              course.code,
              registrationCode,
              userCourse.aa,
            );
            notices = ABILITAZIONE60CFUMANIFESTO_REGGIO.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "CORSI3036":
            cards = await CORSI3036.getDashboardCards(
              course.code,
              registrationCode
            );
            notices = CORSI3036.getDashboardNotices(
              course.code,
              userCourse.pluginConfig.competitionClass,
              userCourse.aa,
            );
            break;

          case "TFAINDIRE":
            cards = await TFAINDIRE.getDashboardCards(course.code, registrationCode);
            notices = TFAINDIRE.getDashboardNotices(course.code, registrationCode);
            break;

          case "TFAINDIRE_UNICAMILLUS":
            cards = await TFAINDIRE_UNICAMILLUS.getDashboardCards(course.code, registrationCode);
            notices = TFAINDIRE_UNICAMILLUS.getDashboardNotices(course.code, registrationCode);
            break;

          case "TFACLASSICO_UNICAMILLUS":
            cards = await TFACLASSICO_UNICAMILLUS.getDashboardCards(course.code, registrationCode);
            notices = TFACLASSICO_UNICAMILLUS.getDashboardNotices(course.code, registrationCode);
            break;

          default:
            cards = this.getDefault();
        }
      }
    }

    if (cards.length <= 0) {
      try {
        //cards = this.getFixedCards();
        const result = await courseService.perfezionamentoActiveLink(
          registrationCode
        );
        if (result.data.payload) {
          const { payload } = result.data;
          if (payload.examReservationEnabled === "1") {
            cards.push({
              title: "Prenotazione Esami",
              link: ROUTES.COURSE_EXAMFINAL_ONSITE_RESERVATION, // ROUTES.COURSE_EXAM_WRITTEN_RESERVATION,
              img: "/img/icon/badge.png",
              className: "image-box",
            });
          }
          if (payload.writtenEnabled === "1") {
            cards.push({
              title: "Prova di Profitto",
              link: ROUTES.PERFEZIONAMENTO_EXAM_WRITTEN,
              img: "/img/icon/badge.png",
              className: "image-box",
            });
          }
          if (payload.liveReservationEnabled === "1") {
            cards.push({
              title: "Prenotazione Esami Orali",
              link: ROUTES.COURSE_EXAM_LIVE_RESERVATION,
              img: "/img/icon/8.png",
              className: "image-box",
            });
          }
          if (payload.isLinkExamEnabled === "1") {
            cards.push({
              title: "Avvio di Google Meet",
              link: ROUTES.PERFEZIONAMENTO_EXAM_LIVE,
              img: "/img/icon/call.png",
              className: "image-box",
            });
          }
          if (payload.titleRequestEnabled === "1") {
            cards.push({
              title: "Richiesta Certificazione e Pergamena",
              link: ROUTES.COURSE_TITLE_REQUEST,
              img: "/img/icon/graduate.png",
              className: "image-box",
            });
          }
          /*
                                        RICHIESTA DA FRANESCO in DATA 03/10/2022 via skype
                                        if (payload.titleSelfEnabled === '1') {
                                            cards.push({
                                                title: 'Piano di Studi',
                                                link: ROUTES.COURSE_TITLE_SELF_DECLARATION,
                                                img: '/img/icon/graduate.png', className: 'image-box'
                                            });
                                        }
                    */
        }
      } catch (error) { }
    }

    return { cards, notices };
  }

  static async getDefault() {
    const cards = this.getFixedCards();
    return { cards, notices: [] };
  }

  static getFixedCards() {
    return [
      {
        title: "Materiale didattico",
        link: ROUTES.LEARNING_MAIN,
        img: "/img/icon/lessons.png",
        className: "image-box",
      },
      {
        title: "Invio materiale",
        link: ROUTES.LEARNING_FINAL_PAPER,
        img: "/img/icon/document.png",
        className: "image-box",
      },
      {
        title: "Istruzioni Operative",
        link: ROUTES.COURSE_ISTRUCTION,
        img: "/img/icon/graduate.png",
        className: "image-box",
      },
      {
        title: "Bando e Regolamenti",
        link: ROUTES.COURSE_DOCS,
        img: "/img/icon/graduate.png",
        className: "image-box",
      },
      {
        title: "Messaggi",
        link: ROUTES.COURSE_TICKETS,
        img: "/img/icon/message.png",
        className: "image-box",
      },
      {
        title: "Tutor didattico",
        link: ROUTES.COURSE_TUTOR,
        img: "/img/icon/call.png",
        className: "image-box",
      },
      {
        title: "Situazione pagamenti",
        link: ROUTES.COURSE_PAYMENTS,
        img: "/img/icon/payment.png",
        className: "image-box",
      },
      {
        title: "Fatture",
        link: ROUTES.COURSE_INVOICES,
        img: "/img/icon/invoice.png",
        className: "image-box",
      },
      {
        title: "Progetto Corso Gratuito",
        link: ROUTES.COURSE_PROVIDER,
        img: "/img/icon/euro2.png",
        className: "image-box",
      },
    ];
  }
}
